module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Regular.754484a2.svg";